/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class UserProviderConfig {
        public tag: string;
        public selectedUser: any;
    }

    export class Grant {
        id: string;
        uniqueId: string;
        name: string;
        claimValues: GrantValue[];
    }

    export class GrantValue {
        id: string;
        uniqueId: string;
        name: string;
    }

    export class UserClaim {
        claimIndex: number;
        claimUniqueId: string;
        claimValueUniqueId: string;
        newClaimUniqueId: string;
        options: GrantValue[];
    }

    export class UserAdministrationModel{

        public systemLevel: Wars.Domain.Model.SystemLevel;
        public userProviders: UserProviderConfig[];
        public grants: Grant[];
        public userId: string;
        public users: any;
        public filteredUsers: any;
        public selectedUser: any;

        constructor(private userAdministrationService: services.UserAdministrationService, private userService: services.UserService, private filter: angular.IFilterService) {
            var self = this;
            self.userProviders = [];
            self.userAdministrationService.getUserGrantAuthorizations()
                .then((result) => {
                    self.userId = result.userId;
                    self.grants = result.options;
                    self.userAdministrationService.getUserProviders()
                        .then((result) => {
                            if (result.length != undefined) {
                                for (var i = 0; i < result.length; i++) {
                                    var upc = new UserProviderConfig();
                                    upc.tag = result[i].tag;
                                    self.userProviders.push(upc);
                                }
                                self.userProviders = Enumerable.from(self.userProviders).orderBy(x => x.tag).toArray();
                            }
                            self.userAdministrationService.getUsers(self.userProviders)
                                .then((result) => {
                                    self.users = result;
                                    self.filteredUsers = self.users;
                                });
                        });
                });
        } 

        public paging = {
            currentPage: 1,
            pageSize: 50,
            goToPage: 1
        }

        public filters = {
            firstName: "",
            lastName: "",
            userId: "",
            email: "",
            claimName: "",
            claimValue: ""
        }

        public getTotalPages()  {
            if (this.filteredUsers) return 0;
            return this.filteredUsers.length > 0 ? Math.ceil(this.filteredUsers.length / this.paging.pageSize) : 1;
        }

        public setCurrentPage() {
            if (this.paging.goToPage > 0 && this.paging.goToPage <= this.getTotalPages()) {
                this.paging.currentPage = this.paging.goToPage;
            }
        }

        public setGoToPage() {
            this.paging.goToPage = this.paging.currentPage;
        }

        public filterUsers() {
            this.paging.currentPage = 1;
            this.paging.goToPage = 1;
            this.filteredUsers = this.filter('filter')(this.users,
                {
                    firstName: this.filters.firstName,
                    lastName: this.filters.lastName,
                    externalSystemUserName: this.filters.userId,
                    email: this.filters.email,
                    userClaims: {
                        claimName: this.filters.claimName,
                        claimValueName: this.filters.claimValue
                    }
                }
            );
        }

        public userSelected(item: Wars.Domain.Model.Dtos.UserSearchDto, provider: UserProviderConfig) {
            var self = this;
            provider.selectedUser = item;
            if (!provider.selectedUser) return;
            self.selectedUser = Enumerable.from(self.users).where(i => (<any>i).externalId === provider.selectedUser.id && (<any>i).provider === provider.selectedUser.provider).firstOrDefault();
        }

        public addUserClaim(selectedUser) {
            if (selectedUser.userClaims == null) {
                selectedUser.userClaims = [];
            }
            var uc = new UserClaim();
            uc.claimIndex = selectedUser.userClaims.length;
            selectedUser.userClaims.push(uc);
        }

        public removeUserClaim(selectedUser, userClaim) {
            if (selectedUser.userClaims == null || selectedUser.userClaims.length === 0) return;
            selectedUser.userClaims = Enumerable.from(<UserClaim[]>selectedUser.userClaims).where(i => i.claimIndex !== userClaim.claimIndex).toArray();
        }

        public setClaimOptions(userClaim: UserClaim) {
            var self = this;
            userClaim.options = [];
            if (userClaim.claimUniqueId != null) {
                userClaim.options = Enumerable.from(self.grants).first(i => i.uniqueId === userClaim.claimUniqueId).claimValues;
            } 
            if (userClaim.newClaimUniqueId != null) {
                userClaim.options = Enumerable.from(self.grants).first(i => i.uniqueId === userClaim.newClaimUniqueId).claimValues;
            } 
            if (userClaim && userClaim.options && userClaim.options.length && userClaim.options.length > 0) {
                userClaim.options = Enumerable.from(userClaim.options).distinct(x => x.uniqueId).toArray();
            }
        }

        public canSaveUser(selectedUser) {
            if (selectedUser.userClaims == null || selectedUser.userClaims.length === 0) return false;
            for (var i = 0; i < selectedUser.userClaims.length; i++) {
                var uc = <UserClaim>selectedUser.userClaims[i];
                if (uc.claimUniqueId == null || uc.claimUniqueId.trim() === "") return false;
                if (uc.options != null && uc.options.length > 0) {
                    if (uc.claimValueUniqueId == null || uc.claimValueUniqueId.trim() === "") return false;
                }
            }
            return true;
        }

        public canAddUserClaim(user) {
            if (user.newClaimUniqueId == null || user.newClaimUniqueId.trim() === "") return false;
            if (user.options != null && user.options.length > 0) {
                if (user.newClaimValueUniqueId == null || user.newClaimValueUniqueId.trim() === "") return false;
            }
            return true;
        }

        public addUserNewClaim(user) {
            var self = this;
            self.userAdministrationService.addUserNewClaim(user)
                .then((result) => {
                    if (result.length === 1) {
                        user.userClaims = result[0].userClaims;
                        user.newClaimUniqueId = null;
                        user.newClaimValueUniqueId = null;
                        user.options = null;
                    }
                    if (user.id === self.userId) {
                        self.userAdministrationService.getUserGrantAuthorizations()
                            .then((result) => {
                                self.userId = result.userId;
                                self.grants = result.options;
                            });
                    }
                });
        }

        public addUser(provider) {
            var self = this;
            self.userAdministrationService.addUser(provider.selectedUser)
                .then((result) => {
                    provider.selectedUser = null;
                    if (result.length === 1) {
                        self.users.push(result[0]);
                    }
                });
        }

        public removeClaim(user, claim) {
            var self = this;
            var removeUser = false;
            if (user.userClaims.length === 1) {
                removeUser = true;
            }
            self.userAdministrationService.removeClaim(claim.id)
                .then(() => {
                    if (removeUser) {
                        self.users = Enumerable.from(self.users).where(i => (<any>i).id !== user.id).toArray();
                        self.filterUsers();
                    } else {
                        user.userClaims = Enumerable.from(user.userClaims).where(i => (<any>i).id !== claim.id).toArray();
                    }
                });
        }

        private searchUsers(viewValue, provider: UserProviderConfig): any {
            if (viewValue.length == undefined || viewValue.length < 3) return null;
            var self = this;
            var searchCriteria = new models.UserSearchCriteria();
            searchCriteria.userRepository = provider.tag;
            searchCriteria.userName = viewValue;
            return self.userService.searchUsers(searchCriteria);
        }
    }
}